import { Reveal } from "./Reveal";
import { Star } from "lucide-react";

const PORTRAIT =
  "https://images.unsplash.com/photo-1603574670812-d24560880210?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwaG90b2dyYXBoZXIlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODQ4OTgxNDB8MA&ixlib=rb-4.1.0&q=85";

export default function Testimonial() {
  return (
    <section id="temoignage" className="py-24 md:py-32 scroll-mt-20" data-testid="testimonial-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid lg:grid-cols-12 gap-10 items-center">
        <Reveal className="lg:col-span-5">
          <div className="relative aspect-[4/5] max-w-sm overflow-hidden">
            <img src={PORTRAIT} alt="Marc L., photographe partenaire" className="w-full h-full object-cover" data-testid="testimonial-portrait" />
            <div className="absolute inset-0 ring-1 ring-inset ring-black/5" />
          </div>
        </Reveal>

        <Reveal className="lg:col-span-7" delay={0.15}>
          <div className="flex gap-1 mb-6" data-testid="testimonial-stars">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-5 h-5 fill-[#F97316] text-[#F97316]" />
            ))}
          </div>
          <blockquote className="text-2xl md:text-4xl font-black tracking-tight text-[#0A0A0A] leading-[1.15]">
            « Je photographie les couchers de soleil au bord de la piscine. iFotoLife s'occupe du reste et je touche <span className="text-[#F97316]">80 % dès le lendemain</span>. C'est devenu mon revenu principal. »
          </blockquote>
          <div className="mt-8">
            <div className="text-base font-bold text-[#0A0A0A]">Marc L.</div>
            <div className="text-sm text-[#52525B] font-light">Photographe partenaire · Côte d'Azur</div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
